import { createReducer } from 'utilities';
import * as TYPES from './constants';
import { normalize } from 'utilities';

const initialState = {
  results: normalize(),
  fetching: false,
  error: null
};
const reducer = createReducer(initialState, {
  [TYPES.REQUEST](state) {
    return {
      ...state,
      fetching: true
    }
  },
  [TYPES.FAILURE](state, action) {
    return {
      ...state,
      fetching: false,
      error: action.error || true
    }
  },
  [TYPES.SUCCESS](state, { payload }) {
    return {
      ...state,
      fetching: false,
      error: null,
      results: normalize(payload.results)
    }
  },
});

export default reducer;




// WEBPACK FOOTER //
// ./src/ducks/addresses/reducer.js